import React, {
    Dispatch,
    ReactNode,
    SetStateAction,
    createContext,
    useContext,
    useMemo,
    useState,
} from 'react';
import { AcquisitionsLoader } from '../../components/AcquisitionsLoader/AcquisitionsLoader';

interface ILoaderProviderProps {
    children: ReactNode;
}

interface ILoaderValue {
    setProcessingSteps: Dispatch<SetStateAction<Array<string>>>;
    setShouldRenderLoader: Dispatch<SetStateAction<boolean>>;
}

const LoaderContext = createContext<ILoaderValue>({
    setProcessingSteps: () => [],
    setShouldRenderLoader: () => {},
});

export default function LoaderProvider({ children }: ILoaderProviderProps) {
    const [shouldRenderLoader, setShouldRenderLoader] =
        useState<boolean>(false);
    const [processingSteps, setProcessingSteps] =
        useState(['Validating personal information']);
    return (
        <LoaderContext.Provider
            value={useMemo(
                () => ({
                    setProcessingSteps,
                    setShouldRenderLoader,
                }),
                [],
            )}
        >
            {shouldRenderLoader ? (
                <AcquisitionsLoader
                    processingSteps={processingSteps}
                />
            ) : (
                children
            )}
        </LoaderContext.Provider>
    );
}

export const useLoader = () => useContext(LoaderContext);